var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_c('Navbar',{staticClass:"md-layout-item md-small-hide"}),_c('Sidenav',{staticClass:"md-layout-item",attrs:{"id":"sidenav"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }